import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ShowAllMarkdownButtons;
/*
 *                     NOTICE
 *            COPYRIGHT 2026 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { EasterEggs, LocalStorageEasterEgg } from "abreact/app/easterEggs/EasterEggs";
export class ShowAllMarkdownButtons extends LocalStorageEasterEgg {
  constructor() {
    super("ShowAllMarkdownButtons", "Show all Markdown buttons");
  }
}
_ShowAllMarkdownButtons = ShowAllMarkdownButtons;
_defineProperty(ShowAllMarkdownButtons, "easterEgg", new _ShowAllMarkdownButtons());
EasterEggs.registry.register(() => ShowAllMarkdownButtons.easterEgg);
//# sourceMappingURL=ShowAllMarkdownButtons.js.map
